var React = require('react');

function PillsDuotone (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fa-group"},[React.createElement("path",{"className":"fa-secondary","d":"M299.7 226.3a8.21 8.21 0 0 0-12.3.8c-45.3 62.5-40.4 150.1 15.9 206.4s143.9 61.2 206.4 15.9a8.14 8.14 0 0 0 .8-12.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9a8.14 8.14 0 0 0-.8 12.3l210.8 210.8a8.21 8.21 0 0 0 12.3-.8c45.3-62.6 40.5-150.1-15.9-206.4zM112 32A111.94 111.94 0 0 0 0 144v112h224V144A111.94 111.94 0 0 0 112 32z","opacity":"0.4","key":0}),React.createElement("path",{"className":"fa-primary","d":"M224 256v112a112 112 0 0 1-224 0V256z","key":1})]));
}

PillsDuotone.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fad","data-icon":"pills","className":"svg-inline--fa fa-pills fa-w-18","role":"img","viewBox":"0 0 576 512"};

module.exports = PillsDuotone;

PillsDuotone.default = PillsDuotone;
